const language = {
  '-1': {
    'zh_CN': '未知错误',
    'en': 'Unknown Error'
  },
  '1': {
    'zh_CN': '服务中心',
    'en': ``
  },
  '2': {
    'zh_CN': '签到',
    'en': ``
  },
  '3': {
    'zh_CN': '签到的第<span class="big">{0}</span>天',
    'en': ``
  },
  '4': {
    'zh_CN': '明天签到得{0}积分',
    'en': ``
  },
  '5': {
    'zh_CN': '获取中...',
    'en': `Loading`
  },
  '6': {
    'zh_CN': '暂无热搜',
    'en': `not yet`
  },
  '7': {
    'zh_CN': '下拉刷新',
    'en': `pull to refresh`
  },
  '8': {
    'zh_CN': '松手看看吧',
    'en': `leave~`
  },
  '9': {
    'zh_CN': '刷新成功',
    'en': `Success`
  },
  '10': {
    'zh_CN': '拼命加载中',
    'en': `Loading...`
  },
  '11': {
    'zh_CN': '上次更新时间：',
    'en': `last refresh`
  },
  '12': {
    'zh_CN': '本次更新时间：',
    'en': `refresh time`
  },
  '13': {
    'zh_CN': '维护中...',
    'en': `under maintenance`
  },
  '14': {
    'zh_CN': '每日爆款',
    'en': ` In vogue`
  },
  '15': {
    'zh_CN': '热销爆品',
    'en': `Best Sellings`
  },
  '16': {
    'zh_CN': '更多',
    'en': `More`
  },
  '17': {
    'zh_CN': '神券商品',
    'en': `Coupon Goods`
  },
  '18': {
    'zh_CN': '团购商品',
    'en': `Group-buying`
  },
  '19': {
    'zh_CN': '查看更多',
    'en': `More`
  },
  '20': {
    'zh_CN': '秒杀商品',
    'en': `Sec-killing`
  },
  '21': {
    'zh_CN': '超市百货',
    'en': `Grocery`
  },
  '22': {
    'zh_CN': '家居日用',
    'en': `Household`
  },
  '23': {
    'zh_CN': '美妆穿搭',
    'en': `Beauty`
  },
  '24': {
    'zh_CN': '图书文具',
    'en': `Books`
  },
  '25': {
    'zh_CN': '9.9专区',
    'en': `9.9 Sales`
  },
  '26': {
    'zh_CN': '超级大卖场',
    'en': `Super Outlet`
  },
  '27': {
    'zh_CN': '数码家电',
    'en': `Digital`
  },
  '28': {
    'zh_CN': '医药保健',
    'en': `Health`
  },
  '29': {
    'zh_CN': '自营',
    'en': `Self-selling`
  },
  '30': {
    'zh_CN': '享购攻略',
    'en': `Shoping Guide`
  },
  '31': {
    'zh_CN': '关于订单',
    'en': `About Orders `
  },
  '32': {
    'zh_CN': '1.已确认的订单为何会失效？',
    'en': `Why does the confirmed order become invalid?`
  },
  '33': {
    'zh_CN': '如果确认收货之后在走售后流程，如：退货退邮费等订单都可能会失效哦！',
    'en': `If you follow the after-sales process after confirming the receipt, such as return the goods or express fee, the orders may become invalid!`
  },
  '34': {
    'zh_CN': '2.有订单笔数为何没有佣金显示？',
    'en': `There are the numbers of orders, but why no cashback? `
  },
  '35': {
    'zh_CN': '您可以确认一下您的下单时间，任何订单都可能出现订单延迟。',
    'en': `You can confirm the time of your order. Any order may be delayed`
  },
  '36': {
    'zh_CN': '3.所有订单多久才能在我的订单中显示？',
    'en': `How long will it take for all orders to appear in my order?`
  },
  '37': {
    'zh_CN': '一般在3分钟以内可以同步到，不同时间段不同平台同步的时间略有差异。',
    'en': `Generally, it can be synchronized within 3 minutes, and the synchronization time of different platforms in different time periods is slightly different.`
  },
  '38': {
    'zh_CN': '关于佣金返利',
    'en': `About Cashback`
  },
  '39': {
    'zh_CN': '1.什么时候可以提现？',
    'en': `1.When can I withdraw?`
  },
  '40': {
    'zh_CN': '本月已完成的结算订单到下月25号后都可以提现。',
    'en': `The settlement orders that have been completed this month can be withdrawn after the 25th of the next month.`
  },
  '41': {
    'zh_CN': '2.为什么下单后没有佣金返利？',
    'en': `Why is there no cashback after placing an order?`
  },
  '42': {
    'zh_CN': '【大家注意】购买时请注意以下几点，以下购买方式会得不到佣金哦',
    'en': `[Attention] Please pay attention to the following points when purchasing！The following purchase methods will not receive the cashback.`
  },
  '43': {
    'zh_CN': '领券后 加入购物车或收藏之后购买',
    'en': `After receiving the coupon, goods were added to cart or favorites, and then purchase`
  },
  '44': {
    'zh_CN': '使用集分宝、红包以及其他第三方优惠',
    'en': `Use Red Packets or other third-party discount`
  },
  '45': {
    'zh_CN': '领券后 拍了店铺的其他商品',
    'en': `After receiving the coupon, users by other products in the store`
  },
  '46': {
    'zh_CN': '咨询店家时 通过客服发的商品链接下单',
    'en': `place an order through the product link sent by the customer service`
  },
  '47': {
    'zh_CN': '使用非官方购物APP以外的其他任何手机APP下单',
    'en': `Use any mobile Apps other than the official one to place an order`
  },
  '48': {
    'zh_CN': '正确的下单方式：',
    'en': `The correct way to place an order:`
  },
  '49': {
    'zh_CN': '关于优惠券',
    'en': `About Coupon`
  },
  '50': {
    'zh_CN': '1.为什么领券时提示优惠券已失效？',
    'en': `1.Why is it prompted that the coupon has expired when receiving the coupon?`
  },
  '51': {
    'zh_CN': '商家提供的优惠券失效',
    'en': `The coupon provided by the merchant is invalid`
  },
  '52': {
    'zh_CN': '2.领券下单一直无法跳转怎么解决？',
    'en': `2. How to solve the problem that the order cannot be redirected after receiving the coupon?`
  },
  '53': {
    'zh_CN': '网络问题导致，当前手机连接的网络存在问题，可以尝试切换或重新连接一次；',
    'en': `Due to poor network, the network currently connected to the mobile phone has some problem, and you can try to switch or reconnect;`
  },
  '54': {
    'zh_CN': 'APP更新或连接问题导致，可以尝试关闭APP重新打开；',
    'en': `Because of app updating or connection problem, you can try to close the app and reopen it;`
  },
  '55': {
    'zh_CN': '关于分享推广',
    'en': `About Promotion`
  },
  '56': {
    'zh_CN': '1.怎么分享推广赚',
    'en': `1. How to share the promotion`
  },
  '57': {
    'zh_CN': '在app享购商城中，打开您想要推广分享的商品，商品页下方点击“分享赚”，即可复制所需分享的商品链接等信息，进行推广；',
    'en': `In the shop of the app, you can open the product you want to promote and share, and click "Share" at the bottom of the product page to copy the product link and other information you want to share for promotion`
  },
  '58': {
    'zh_CN': '2.怎么邀请注册？',
    'en': `2. How to invite others?`
  },
  '59': {
    'zh_CN': `打开APP进入“我的”，点击“我的邀请码”生成我的专属邀请海报，点击“保存图片至相册”，也可复制“我的邀请码”，将邀请码或海报图片发送给您要邀请的人，让他通过邀请码注册或通过识别海报中的二维码注册下载即可。`,
    'en': `Open the APP and choose "My", click "My Invitation Code" to generate my exclusive invitation poster, click "Save Picture to Album", or copy "My Invitation Code", and then send the invitation code or poster to the one you want to invite. He can register with the invitation code or download via recognizing the QR code in the poster.`
  },
  '60': {
    'zh_CN': '关于提现',
    'en': `About Withdraw`
  },
  '61': {
    'zh_CN': '1.如何提现',
    'en': `1. How to withdraw`
  },
  '62': {
    'zh_CN': `打开APP，点击“享购”我的导师中心，点击“提现”，如用户当前有可提现金额，输入是支付宝帐号，姓名，提现金额可申请提现，提现24小时内到帐。单笔提现金额10~10,000元，不支持小数位，单账户每日可提现笔数为3笔。`,
    'en': `Open the APP, click "Guider" on "Shopping", and click "Withdraw". If there is available amount, users should enter their Alipay account, name, and withdraw number to withdraw. The withdrawal will arrive within 24 hours. The single withdrawal amount is 10~10,000 yuan, and decimal places are not supported. The number of withdrawals per day for a single account is 3.`
  },
  '63': {
    'zh_CN': `2.为什么提现时，显示今日提现金额已达上限？`,
    'en': `2. Why does it show that the amount of cash withdrawn today has reached the upper limit when withdrawing?`
  },
  '64': {
    'zh_CN': `目前支付宝限额每日可转出上限100万，24点后当日可已转账额度归零，如提示上限提醒，用户可次日申请提现，不便之处敬请谅解！`,
    'en': `At present, the Alipay can be transferred out 1 million per day at most. After 24:00 of the day, the transfer limit will be reset to zero. If the upper limit reminder is prompted, the user can apply for withdrawal next day. Sorry for the inconvenience!`
  },
  '65': {
    'zh_CN': `剩余查询次数`,
    'en': `rest times`
  },
  '66': {
    'zh_CN': `充值`,
    'en': `Deposit`
  },
  '67': {
    'zh_CN': `明细`,
    'en': `Details`
  },
  '68': {
    'zh_CN': `------- 没有更多 -------`,
    'en': `------- No more -------`
  },
  '69': {
    'zh_CN': `查询交易记录`,
    'en': `search the transaction record`
  },
  '70': {
    'zh_CN': `充值`,
    'en': `Deposit`
  },
  '71': {
    'zh_CN': `使用明细`,
    'en': `Details`
  },
  '72': {
    'zh_CN': `请输入BTD账户查询`,
    'en': `please enter the BTD account to search`
  },
  '73': {
    'zh_CN': `剩余查询次数：`,
    'en': `rest times`
  },
  '74': {
    'zh_CN': `明细`,
    'en': `Details`
  },
  '75': {
    'zh_CN': `查询`,
    'en': `search`
  },
  '76': {
    'zh_CN': `最近查询`,
    'en': `latest `
  },
  '77': {
    'zh_CN': `交易查询`,
    'en': `search the transaction history`
  },
  '78': {
    'zh_CN': `请先充值`,
    'en': `please deposit first`
  },
  '79': {
    'zh_CN': `账户格式不正确`,
    'en': `incorrect format`
  },
  '80': {
    'zh_CN': `BTD账户`,
    'en': `BTD account`
  },
  '81': {
    'zh_CN': `账户余额`,
    'en': `balance`
  },
  '82': {
    'zh_CN': `交易记录`,
    'en': `Transaction History`
  },
  '83': {
    'zh_CN': `转出手续费：`,
    'en': `transfer-out fee：`
  },
  '84': {
    'zh_CN': `交易状态：`,
    'en': `status：`
  },
  '85': {
    'zh_CN': `成功`,
    'en': `success`
  },
  '86': {
    'zh_CN': `失败`,
    'en': `fail`
  },
  '87': {
    'zh_CN': `交易地址：`,
    'en': `address：`
  },
  '88': {
    'zh_CN': `交易类型：`,
    'en': `type：`
  },
  '89': {
    'zh_CN': `交易哈希：`,
    'en': `hash：`
  },
  '90': {
    'zh_CN': `交易备注：`,
    'en': `note：`
  },
  '91': {
    'zh_CN': `查看下10条交易记录`,
    'en': `search next 10 transaction history`
  },
  '92': {
    'zh_CN': `未信任`,
    'en': `Untrusted`
  },
  '93': {
    'zh_CN': `冻结`,
    'en': ` frozen`
  },
  '94': {
    'zh_CN': `正常`,
    'en': `normal`
  },
  '95': {
    'zh_CN': `未信任`,
    'en': `untrusted`
  },
  '96': {
    'zh_CN': `查询结果`,
    'en': `result`
  },
  '97': {
    'zh_CN': `复制成功`,
    'en': `Copy successfully`
  },
  '98': {
    'zh_CN': `复制失败`,
    'en': `Copy failed`
  },
  '99': {
    'zh_CN': `充值查询次数`,
    'en': `add search number`
  },
  '100': {
    'zh_CN': `每次`,
    'en': `each time`
  },
  '101': {
    'zh_CN': `充值数量`,
    'en': `quantity`
  },
  '102': {
    'zh_CN': `共需支付`,
    'en': `pay`
  },
  '103': {
    'zh_CN': `投票记录`,
    'en': `Voting History`
  },
  '104': {
    'zh_CN': `票`,
    'en': `vote`
  },
  '105': {
    'zh_CN': `1票起投`,
    'en': `≥1`
  },
  '106': {
    'zh_CN': `可重复投票`,
    'en': `vote again`
  },
  '107': {
    'zh_CN': `不可重复投票`,
    'en': `cannot vote again`
  },
  '108': {
    'zh_CN': `数据刷新于：`,
    'en': `refresh on：`
  },
  '109': {
    'zh_CN': `投票`,
    'en': `vote`
  },
  '110': {
    'zh_CN': `已结束`,
    'en': `Ended`
  },
  '111': {
    'zh_CN': `未开始`,
    'en': `not started`
  },
  '112': {
    'zh_CN': `已投`,
    'en': `voted`
  },
  '113': {
    'zh_CN': `满票`,
    'en': `full voting`
  },
  '114': {
    'zh_CN': `投票详情`,
    'en': `Details`
  },
  '115': {
    'zh_CN': `请先勾选投票项`,
    'en': `please choose an option first`
  },
  '116': {
    'zh_CN': `进行中`,
    'en': `In Voting`
  },
  '117': {
    'zh_CN': `预热中`,
    'en': `Warming Up`
  },
  '118': {
    'zh_CN': `已结束`,
    'en': `Ended`
  },
  '119': {
    'zh_CN': `议事厅`,
    'en': `Voting hall`
  },
  '120': {
    'zh_CN': `投票选项：`,
    'en': `voting option：`
  },
  '121': {
    'zh_CN': `投票时间：`,
    'en': `voting time：`
  },
  '122': {
    'zh_CN': `投票账户：`,
    'en': `voting account：`
  },
  '123': {
    'zh_CN': `{0}票起投，{1}{2}=1票`, //1票起投，10BTD=1票
    'en': `please vote at least {0}, {1}{2}=1 voting`
  },
  '124': {
    'zh_CN': `选项`,
    'en': `options`
  },
  '125': {
    'zh_CN': `投票数量`,
    'en': `voting number`
  },
  '126': {
    'zh_CN': `共需支付`,
    'en': `pay`
  },
  '127': {
    'zh_CN': `去支付`,
    'en': `go`
  },
  '128': {
    'zh_CN': `比特米基金会(新加坡)`,
    'en': `BitRice Foundation (Singapore)`
  },
  '129': {
    'zh_CN': `距离投票结束`,
    'en': `rest voting time`
  },
  '130': {
    'zh_CN': `投票结束于`,
    'en': `end at `
  },
  '131': {
    'zh_CN': `开始时间`,
    'en': `start at`
  },
  '132': {
    'zh_CN': `比特米基金会`,
    'en': `BitRice Foundation`
  },
  '133': {
    'zh_CN': `发布于：`,
    'en': `release at：`
  },
  '134': {
    'zh_CN': `官方`,
    'en': `Official`
  },
  '135': {
    'zh_CN': `邀请好友购买比特盘福袋`,
    'en': `invite friends，buy lucky bags`
  },
  '136': {
    'zh_CN': `{0}刚邀请了1位好友，获得100元`, // 小李刚邀请了1位好友，获得100元
    'en': `{0} has invite a friend and get 100 yuan cashback`
  },
  '137': {
    'zh_CN': `获得返利`,
    'en': `cashback`
  },
  '138': {
    'zh_CN': `去提现`,
    'en': `withdraw`
  },
  '139': {
    'zh_CN': `返利明细`,
    'en': `details`
  },
  '140': {
    'zh_CN': `邀请好友赚更多返利`,
    'en': `Invite friends`
  },
  '141': {
    'zh_CN': `剩余奖励份额：`,
    'en': `Rest Quota：`
  },
  '142': {
    'zh_CN': `活动规则`,
    'en': `Rules`
  },
  '143': {
    'zh_CN': `分享活动`,
    'en': `Share the link `
  },
  '144': {
    'zh_CN': `给好友`,
    'en': `with friends`
  },
  '145': {
    'zh_CN': `好友应邀注册云盘`,
    'en': `Friends sign in via the sharing link`
  },
  '146': {
    'zh_CN': `并认证`,
    'en': `and certify `
  },
  '147': {
    'zh_CN': `好友购买`,
    'en': `Friends buy`
  },
  '148': {
    'zh_CN': `福袋`,
    'en': `Lucky Bag`
  },
  '149': {
    'zh_CN': `比特盘福袋限量10W，先到先得，买完即止`,
    'en': `The lucky bag Limited to 10W, first come first served`
  },
  '150': {
    'zh_CN': `举个例子`,
    'en': `For example`
  },
  '151': {
    'zh_CN': `好友购买`,
    'en': `Friends buy`
  },
  '152': {
    'zh_CN': `花费`,
    'en': `Spend`
  },
  '153': {
    'zh_CN': `您将获得`,
    'en': `You will get`
  },
  '154': {
    'zh_CN': `比特盘福袋`,
    'en': `Bitdisk Lucky Bag`
  },
  '155': {
    'zh_CN': `查看完整活动规则`,
    'en': `View the complete rules`
  },
  '156': {
    'zh_CN': `活动最终解析权归新加坡比特米基金会所有`,
    'en': `BitRice Foundation reserves all rights of this activity`
  },
  '157': {
    'zh_CN': `收益明细`,
    'en': `details`
  },
  '158': {
    'zh_CN': `购买福袋`,
    'en': `but the lucky bag`
  },
  '159': {
    'zh_CN': `注册比特盘得豪礼`,
    'en': `Register BitDisk and get fabulous gifts`
  },
  '160': {
    'zh_CN': `积分(个)`,
    'en': `point`
  },
  '161': {
    'zh_CN': `奖励分红(BTD)`,
    'en': `incentives(BTD)`
  },
  '162': {
    'zh_CN': `奖券(张)`,
    'en': `coupon`
  },
  '163': {
    'zh_CN': `推荐注册比特盘，享多重豪礼！`,
    'en': `invite others to register BitDisk with your sharing link to win fabulous gifts`
  },
  '164': {
    'zh_CN': `暂无信息...`,
    'en': `no message...`
  },
  '165': {
    'zh_CN': `我的推荐码`,
    'en': `referral code`
  },
  '166': {
    'zh_CN': `立即邀请`,
    'en': `invite now`
  },
  '167': {
    'zh_CN': `累计推荐认证用户：`,
    'en': `all referral users：`
  },
  '168': {
    'zh_CN': `推荐注册得奖励分红`,
    'en': `all incentives`
  },
  '169': {
    'zh_CN': `被推荐人注册并认证`,
    'en': `invitee`
  },
  '170': {
    'zh_CN': `奖励分红`,
    'en': `incentives`
  },
  '171': {
    'zh_CN': `BTD/人`,
    'en': `BTD/each`
  },
  '172': {
    'zh_CN': `能量值`,
    'en': `Energy point`
  },
  '173': {
    'zh_CN': `个`,
    'en': ``
  },
  '174': {
    'zh_CN': `能量值发放需满足以下条件`,
    'en': `The Energy point need to meet the following conditions`
  },
  '175': {
    'zh_CN': `被推荐人需在比特盘 APP内签到（2能量值/次）`,
    'en': `Referees need to sign in in the BitDisk APP (2 Energy point each time)`
  },
  '176': {
    'zh_CN': `豪礼二：累计推广得奖券`,
    'en': `Gift 2: Promotion to win coupons`
  },
  '177': {
    'zh_CN': `成功推广认证用户`,
    'en': `Successfully promote validated users`
  },
  '178': {
    'zh_CN': `BTD 复投存力池券 x1`,
    'en': `BTD Pool coupon x1`
  },
  '179': {
    'zh_CN': `账户累计推广1000认证账户，获得复投存力池券一张100`,
    'en': `Accumulatively promote 1,000 validated accounts and get a Primary Pool coupon`
  },
  '180': {
    'zh_CN': `领取`,
    'en': `Get`
  },
  '181': {
    'zh_CN': `BTD 复投存力池券 x2/5`,
    'en': `BTD Pool coupon x2/5`
  },
  '182': {
    'zh_CN': `账户累计推广5000认证账户，获得复投存力池券2/5张100`,
    'en': `Accumulatively promote 5,000 validated accounts and get 2/5 Primary Pool coupon`
  },
  '183': {
    'zh_CN': `账户累计推广10000认证账户，获得复投存力池券1张1000`,
    'en': `Accumulatively promote 10,000 validated accounts and get a Medium Pool coupon`
  },
  '184': {
    'zh_CN': `账户累计推广50000认证账户，获得复投存力池券2/5张1000`,
    'en': `Accumulatively promote 50,000 validated accounts and get 2/5 Medium Pool coupon`
  },
  '185': {
    'zh_CN': `补产券`,
    'en': `Re-output Coupon`
  },
  '186': {
    'zh_CN': `单日推广200+人获得补产券一张每日50张，达标既送，先到先得，当日送完即止`,
    'en': `Promoting 200+ users within one day will get a Re-output coupon. The total number per day is 50, which will be given as soon as the standard is met, first-come-first-served.`
  },
  '187': {
    'zh_CN': `剩余20/50张`,
    'en': `20/50 coupons left`
  },
  '188': {
    'zh_CN': `高级存力池碎片`,
    'en': `pieces of Senior Pool`
  },
  '189': {
    'zh_CN': `周推广1200+人获得高级存力池券碎片一张每周发放100张，先到先得`,
    'en': `Promoting 1200+ users within one week will get a piece of Senior Pool. The total number each week is 50, first-come-first-served.`
  },
  '190': {
    'zh_CN': `豪礼三：体验比特盘送积分`,
    'en': `Gift 3: experience BitDisk, get points`
  },
  '191': {
    'zh_CN': `打开比特盘`,
    'en': `open BitDisk`
  },
  '192': {
    'zh_CN': `+2积分`,
    'en': `+2 points`
  },
  '193': {
    'zh_CN': `下载比特盘`,
    'en': `download BitDisk`
  },
  '194': {
    'zh_CN': `1.活动截止方式`,
    'en': `1. how will the activity end`
  },
  '195': {
    'zh_CN': `100,000份售罄`,
    'en': `100,000 sold out`
  },
  '196': {
    'zh_CN': `2.参与资格`,
    'en': `2.Who can participate`
  },
  '197': {
    'zh_CN': `凡通过本活动页分享页注册并认证的比特盘购买福袋用户，即可获得参与资格。`,
    'en': `All users who have registered and authenticated BitDisk through the sharing page of this activity page to purchase lucky bags will be eligible to participate`
  },
  '198': {
    'zh_CN': `3.邀请方式`,
    'en': `3.How to invite friends`
  },
  '199': {
    'zh_CN': `邀请者分享本活动的个人邀请链接或二维码海报给好友，好友受邀并通过该链接或二维码成为比特盘实名用户；`,
    'en': `The User shares the personal invitation link or QR code poster of this activity to a friend, and the friend is invited and becomes a real-name user of BitDisk through the link or QR code;`
  },
  '200': {
    'zh_CN': `受邀者完成购买福袋；`,
    'en': `The invitee buy the lucky bags;`
  },
  '201': {
    'zh_CN': `被邀请者必须为之前未注册过比特盘的用户；`,
    'en': `The invitee must be not registered with BitDisk before;`
  },
  '202': {
    'zh_CN': `不得使用违反所在国家法律法规或非正当方式（诱导、哄骗等）进行邀请推广；`,
    'en': `Do not use any illegal methods (induction, coaxing, etc.) to promote invitations that violate the laws and regulations of the country where you are located;`
  },
  '203': {
    'zh_CN': `4.邀请奖励`,
    'en': `4. What is the invitation reward`
  },
  '204': {
    'zh_CN': `受邀用户购买福袋前，需先行完成认证操作，否则奖励将不发放；`,
    'en': `Invited users need to complete the authentication before buying the lucky bags, otherwise the rewards will not be given;`
  },
  '205': {
    'zh_CN': `奖励金为福袋实际支付金额的50%计算；（因扣除税原因，以实际发放为准）`,
    'en': `The reward is calculated as 50% of the actual payment amount of the lucky bag; (due to tax deduction, the actual payment shall prevail)`
  },
  '206': {
    'zh_CN': `每名邀请者累计可获得奖励金不设上限（名额售罄即止）`,
    'en': `There is no upper limit for each inviter's accumulative rewards (until sold out)`
  },
  '207': {
    'zh_CN': `邀请所获奖励以现金方式发放至可提现余额，用户自行查看与提现；`,
    'en': `The rewards will be shown in the cashable balance, and the user can check and withdraw on their own;`
  },
  '208': {
    'zh_CN': `5.收益结算`,
    'en': `5. How to settle the cashback`
  },
  '209': {
    'zh_CN': `邀请者获得的每笔奖励金，将于当日，最迟次日入账审核（如遇法定节假日则顺延）`,
    'en': `Each cashback will be credited to the account on the same day and the next day at the latest (in case of statutory holidays, it will be postponed)`
  },
  '210': {
    'zh_CN': `入账审核期预计在3个工作日内完成，奖励金审核通过后即纳入邀请收益账户`,
    'en': `The accounting review period is expected to be completed within 3 working days, and the rewards will be shown in the invitation cashback account after the review is passed.`
  },
  '211': {
    'zh_CN': `自最近一笔奖励金入账完成之日起，邀请收益账户余额有效期3年，若逾期未提现，该余额将自动清零作废。`,
    'en': `The balance of the invitation cashback is valid for 3 years from the date of the completion of the lastest cashback. If the balance is not withdrawn after the expiry date, it will be automatically cleared and voided.`
  },
  '212': {
    'zh_CN': `6.收益提现`,
    'en': `6.How to withdraw`
  },
  '213': {
    'zh_CN': `在进行收益提现之前，待提现账户需要设置提现账户信息，如真实姓名、支付宝账户、手机号码、身份证号码等；`,
    'en': `Before withdrawal, the account to be withdrawn needs to set information, such as real name, Alipay account, mobile phone number, ID number, etc.;`
  },
  '214': {
    'zh_CN': `邀请者每周（每七天）可申请一次，每次最小金额为10元，最大金额为20,000元；`,
    'en': `The inviter can apply once a week (every seven days), the minimum amount is 10 yuan each time, and the maximum amount is 20,000 yuan;`
  },
  '215': {
    'zh_CN': `提现到帐时间预计为申请受理后5个工作日内，具体到帐时间以银行处理时间为准；`,
    'en': `The withdrawal time is expected to be within 5 working days after the application is accepted, and the specific time is subject to the bank's processing time;`
  },
  '216': {
    'zh_CN': `如因提现账户信息设置不当或设置错误而造成提现失败或其他问题，后果由邀请人自行承担。`,
    'en': `If the withdrawal fails or other problems due to improper or incorrect setting of the withdrawal account information, the consequences shall be borne by the inviter.`
  },
  '217': {
    'zh_CN': `7.收益税费`,
    'en': `7. tax of earnings`
  },
  '218': {
    'zh_CN': `对于收益提现，将由支付方代扣代缴并扣减相关税费后向邀请者支付；`,
    'en': `For cash withdrawals, the inviter will receive after the payer withhold and deduct the relevant taxes and fees;`
  },
  '219': {
    'zh_CN': `以上税金仅指推广福袋向邀请者支付所获奖励按现行有效的法规规定，有代发放代扣代缴的相关税费，不包括邀请者年度所得税综合申报等情形下设计税款调整的金额；`,
    'en': `The above taxes only refer to the relevant taxes that are issued and withheld on behalf of the rewards that the promotion lucky bag pays to the inviter in accordance with the current effective regulations, and does not include the amount of the designed tax adjustment in the case of the inviter's annual income tax return;`
  },
  '220': {
    'zh_CN': `如因邀请者提现账户信息设置不当或设置错误，导致无法扣税，发放方有权暂停或不予支付奖励。`,
    'en': `If tax deduction cannot be made due to improper or incorrect setting of the account information of the inviter's withdrawal, the issuer has the right to suspend or refuse to pay the reward.`
  },
  '221': {
    'zh_CN': `8.如用户在活动期间出现包括但不限于虚假邀请、诱骗、恶意捆绑、强制他人消费、流量劫持、以不当手段传播、损害被推广对象声誉等违法违规行为，一经发现，活动方及联合方有权取消其全部奖励、追讨已提现金额并冻结相关帐号。`,
    'en': `8. If the user has any illegal activities including but not limited to false invitations, deception, malicious bundling, compulsory consumption, traffic hijacking, dissemination by improper means, damage to the reputation of the promoted object and other violations of laws and regulations during the activity, once discovered, the active party and the joint party It has the right to cancel all its rewards, recover the amount of cash already withdrawn, and freeze related accounts.`
  },
  '222': {
    'zh_CN': `9.在法律法规允许范围内，举办方可能对活动内容做出调整，并于公布后即时生效，请用户注意活动规则页面相关说明。`,
    'en': `9. Within the laws and regulations, the organizer may make adjustments to the content of the activity, which will take effect immediately after the announcement. Users should pay attention to the relevant instructions on the rules page.`
  },
  '223': {
    'zh_CN': `10.活动提醒：所有参与该活动的用户，即视为已阅读并同意本活动规则，理解并愿意接受本活动规则的约束。`,
    'en': `10. Reminder: All users participating in the activity are deemed to have read and agree to the rules, understand and are willing to accept the constraints of the rules of this activity.`
  },
  '224': {
    'zh_CN': `11.本活动由比特米基金会与合作伙伴共同推出，在法律规则允许范围内，比特米基金会对本活动享有解释权。`,
    'en': `11.This activity is jointly launched by the BTR Foundation and its partners. Within the legal rules, the BTR Foundation has the right to interpret this activity.`
  },
  '225': {
    'zh_CN': `出单榜`,
    'en': `sold list`
  },
  '226': {
    'zh_CN': `暂无`,
    'en': `none`
  },
  '227': {
    'zh_CN': `已售`,
    'en': `sold`
  },
  '228': {
    'zh_CN': `高收益商品榜`,
    'en': `high-earning list`
  },
  '229': {
    'zh_CN': `排行榜`,
    'en': `ranking list`
  },
  '230': {
    'zh_CN': `抽中`,
    'en': `win`
  },
  '231': {
    'zh_CN': `奖品`,
    'en': `prize`
  },
  '232': {
    'zh_CN': `幸运大转盘，等你来挑战`,
    'en': `Wheel of Fortune, prizes are waiting for you`
  },
  '233': {
    'zh_CN': `剩余积分`,
    'en': `rest points`
  },
  '234': {
    'zh_CN': `点击`,
    'en': `click`
  },
  '235': {
    'zh_CN': `抽奖`,
    'en': `lucky draw`
  },
  '236': {
    'zh_CN': `今日剩余抽奖次数`,
    'en': `today's rest times`
  },
  '237': {
    'zh_CN': `活动对象`,
    'en': `participant`
  },
  '238': {
    'zh_CN': `APP认证用户`,
    'en': `validated user of the app`
  },
  '239': {
    'zh_CN': `活动内容`,
    'en': `rules`
  },
  '240': {
    'zh_CN': `1.活动期间，用户登录BTDWallet APP，即有机会参与本幸运大转盘抽奖活动，活动期间每位用户每天可参与`,
    'en': `1. During the activity, users log in to the BTD Wallet and have the opportunity to participate in this Wheel of fortune every day `
  },
  '241': {
    'zh_CN': `10次`,
    'en': `10 times`
  },
  '242': {
    'zh_CN': `每次需消耗`,
    'en': `each time consume`
  },
  '243': {
    'zh_CN': `2个BTD积分`,
    'en': `2 points`
  },
  '244': {
    'zh_CN': `2.用户获得各类券奖励，相关奖励券将直接发放至用户对应的账户中，用户可在`,
    'en': `Users get various coupons which will be issued directly to user's account. The user can chenck in`
  },
  '245': {
    'zh_CN': `中查看，点击使用;`,
    'en': `click to use`
  },
  '246': {
    'zh_CN': `我的-我的卡券`,
    'en': `My Coupon`
  },
  '247': {
    'zh_CN': `3.用户获得积分奖励将直接发放至用户`,
    'en': `3. The points obtained by users will be directly issued to users`
  },
  '248': {
    'zh_CN': `4.用户获得能量值奖励将直接发放至用户`,
    'en': `4. The energy points obtained by the user will be directly issued to the user`
  },
  '249': {
    'zh_CN': `5.抽奖过程中若遇到`,
    'en': `5. . During the lucky draw, if you encounter`
  },
  '250': {
    'zh_CN': `手机故障、网络异常`,
    'en': `mobile phone failures, network abnormalities, etc.,`
  },
  '251': {
    'zh_CN': `等情况，请以“我的卡券”、“我的能量值”、“我的BTD积分”中显示内容为准;`,
    'en': `please refer to the contents displayed in "MyCoupons", "My Energy Points", and "My BTD Points".`
  },
  '252': {
    'zh_CN': `我的-BTD积分`,
    'en': `My-BTD Points`
  },
  '253': {
    'zh_CN': `我的-能量值`,
    'en': `My Energy Point`
  },
  '254': {
    'zh_CN': `6.活动奖励数量依据当期活动设置，先到先得，领完即止;`,
    'en': `6. The number of rewards is based on the settings, first come first served;`
  },
  '255': {
    'zh_CN': `7.本活动最终解释权归比特米基金会所有，如有疑问，请联系客服。`,
    'en': `7. The final interpretation of this activity belongs to the BTR Foundation. If you have any questions, please contact customer service.`
  },
  '256': {
    'zh_CN': `特别声明`,
    'en': `Disclaimer`
  },
  '257': {
    'zh_CN': `您通过本软件参加的任何商业活动或者积分相关活动, 均与Apple Inc.无关`,
    'en': `Any commercial activities or points-related activities you participate in through this software are not related to Apple Inc.`
  },
  '258': {
    'zh_CN': `本产品中出现的任何活动或则抽奖,苹果公司都没有以任何方式参与`,
    'en': `Apple has not participated in any activities or lucky draws that appear in this product in any way`
  },
  '259': {
    'zh_CN': `恭喜您获得了`,
    'en': `Congratulations! You've got`
  },
  '260': {
    'zh_CN': `热销榜单`,
    'en': `Best Sale`
  },
  '261': {
    'zh_CN': `0.2能量值`,
    'en': `0.2 Energy Points`
  },
  '262': {
    'zh_CN': `2能量值`,
    'en': `2 Energy Points`
  },
  '263': {
    'zh_CN': `88积分`,
    'en': `88 Points`
  },
  '264': {
    'zh_CN': `2积分`,
    'en': `2 Points`
  },
  '265': {
    'zh_CN': `幸运II 兑换券`,
    'en': `LuckyII Coupon`
  },
  '266': {
    'zh_CN': `我的-我的卡券`,
    'en': `My-My Coupon`
  },
  '267': {
    'zh_CN': `幸运I 兑换券`,
    'en': `LuckyI Coupon`
  },
  '268': {
    'zh_CN': `补产券`,
    'en': `Re-output Coupon`
  },
  '269': {
    'zh_CN': `谢谢参与`,
    'en': `Null`
  },
  '270': {
    'zh_CN': `立即前往`,
    'en': `Go`
  },
  '271': {
    'zh_CN': `中查看`,
    'en': `check in`
  },
  '272': {
    'zh_CN': `很遗憾，您未中奖`,
    'en': `unfortunately, no award`
  },
  '273': {
    'zh_CN': `不要灰心，再接再厉，再试一次！`,
    'en': `Keep up and try again!`
  },
  '274': {
    'zh_CN': `再抽一次`,
    'en': `T]try again`
  },
  '275': {
    'zh_CN': `看视频有惊喜`,
    'en': `watch the video, get a surprise`
  },
  '276': {
    'zh_CN': `我知道了`,
    'en': `got it`
  },
  '277': {
    'zh_CN': `您的积分不足，快去做任务`,
    'en': `points not enough, go and do the task!`
  },
  '278': {
    'zh_CN': `领取积分吧~`,
    'en': `get the points`
  },
  '279': {
    'zh_CN': `去做任务`,
    'en': `do the tasks`
  },
  '280': {
    'zh_CN': `您今日的抽奖次数已用完，`,
    'en': `Today’s lottery has been used up.`
  },
  '281': {
    'zh_CN': `明日再来吧~`,
    'en': `try again tomorrow!`
  },
  '282': {
    'zh_CN': `看视频获取抽奖机会`,
    'en': `Watch the video, get lucky draw chance`
  },
  '283': {
    'zh_CN': `提交数据失败，请重试～`,
    'en': `Failed to submit data, please try again~`
  },
  '284': {
    'zh_CN': `重新提交`,
    'en': `try again`
  },
  '285': {
    'zh_CN': `幸运大转盘`,
    'en': `Wheel of fortune`
  },
  '286': {
    'zh_CN': `敬请期待`,
    'en': `Coming soon...`
  },
  '287': {
    'zh_CN': `预估赚`,
    'en': `estimated earnings`
  },
  '288': {
    'zh_CN': `现在升级为{0}，立即赚{1}元`, //现在升级为顶级导师，立即赚100元
    'en': `upgrade to {0}, earn {1} yuan`
  },
  '289': {
    'zh_CN': `立即升级`,
    'en': `update now`
  },
  '290': {
    'zh_CN': ` 优惠券`,
    'en': `Coupon`
  },
  '291': {
    'zh_CN': `暂无优惠券`,
    'en': `no coupons`
  },
  '292': {
    'zh_CN': `使用期限：`,
    'en': `expiration time`
  },
  '293': {
    'zh_CN': `相关推荐`,
    'en': `More`
  },
  '294': {
    'zh_CN': `商品详情`,
    'en': `product details`
  },
  '295': {
    'zh_CN': `分享赚`,
    'en': `share to earn`
  },
  '296': {
    'zh_CN': `跳转中...`,
    'en': `Go to URL`
  },
  '297': {
    'zh_CN': `购买省`,
    'en': `saving`
  },
  '298': {
    'zh_CN': `收藏`,
    'en': `favorite`
  },
  '299': {
    'zh_CN': `现价`,
    'en': `current price`
  },
  '300': {
    'zh_CN': `券后价`,
    'en': `price with coupon`
  },
  '301': {
    'zh_CN': `拼购价`,
    'en': `group-buying price`
  },
  '302': {
    'zh_CN': `秒杀价`,
    'en': `seckilling price`
  },
  '303': {
    'zh_CN': `已过优惠券获取时间`,
    'en': `coupon time out`
  },
  '304': {
    'zh_CN': `暂无数据`,
    'en': `no data`
  },
  '305': {
    'zh_CN': `没有搜索结果`,
    'en': `no result`
  },
  '306': {
    'zh_CN': `已失效`,
    'en': `expired`
  },
  '307': {
    'zh_CN': `{0}元券`, // 10元券
    'en': `{0} yuan coupon`
  },
  '308': {
    'zh_CN': `秒杀已结束`,
    'en': `seckilling is over`
  },
  '309': {
    'zh_CN': `享购必推`,
    'en': `best sale`
  },
  '310': {
    'zh_CN': `积分商城`,
    'en': `points store`
  },
  '311': {
    'zh_CN': `今日必推`,
    'en': `today's special`
  },
  '312': {
    'zh_CN': `王牌好货`,
    'en': `ace product`
  },
  '313': {
    'zh_CN': `母婴玩具`,
    'en': `maternal and infant `
  },
  '314': {
    'zh_CN': `全网奖励池`,
    'en': `total reward pool`
  },
  '315': {
    'zh_CN': `本月`,
    'en': `this month`
  },
  '316': {
    'zh_CN': `综合`,
    'en': `all`
  },
  '317': {
    'zh_CN': `佣金`,
    'en': `commission`
  },
  '318': {
    'zh_CN': `销量`,
    'en': `sales`
  },
  '319': {
    'zh_CN': `价格`,
    'en': `price`
  },
  '320': {
    'zh_CN': `期`,
    'en': `No.`
  },
  '321': {
    'zh_CN': `市场价`,
    'en': `market price`
  },
  '322': {
    'zh_CN': `本期您已参与`,
    'en': `You have participated`
  },
  '323': {
    'zh_CN': `名额已满`,
    'en': `full`
  },
  '324': {
    'zh_CN': `参与夺宝`,
    'en': `go Treasure Race`
  },
  '324.1': {
    'zh_CN': `参与夺宝`,
    'en': `go Treasure Race`
  },
  '325': {
    'zh_CN': `揭奖时间：`,
    'en': `Draw time:`
  },
  '326': {
    'zh_CN': `开奖号码：`,
    'en': `Winning number:`
  },
  '327': {
    'zh_CN': `已参加{0}人`, //已参加10人
    'en': `{0} Participant`
  },
  '328': {
    'zh_CN': `参加满`,
    'en': ``
  },
  '329': {
    'zh_CN': `人`,
    'en': `Participants`
  },
  '330': {
    'zh_CN': `公示{0}天后开奖`,//公示3天后开奖
    'en': `Draw after {0} day's publicity`
  },
  '331': {
    'zh_CN': `可兑换一个幸运号码`,
    'en': `redeem a lucky number`
  },
  '332': {
    'zh_CN': `每人每次夺宝只能参与一次每次最多可获得{0}个幸运号码`,//每人每次夺宝只能参与一次每次最多可获得5个幸运号码
    'en': `Each person can only participate in the Treasure Race once, and can get up to {0} lucky numbers each time`
  },
  '333': {
    'zh_CN': `需消耗：`,
    'en': `use: `
  },
  '334': {
    'zh_CN': `确认提交`,
    'en': `confirm`
  },
  '335': {
    'zh_CN': `温馨提示`,
    'en': `Tips`
  },
  '336': {
    'zh_CN': `您有尚未支付订单，是否立即前往操作？`,
    'en': `You have an unpaid order. Do you want to pay it now?`
  },
  '337': {
    'zh_CN': `请输入有效数字`,
    'en': `Please enter a valid number`
  },
  '338': {
    'zh_CN': `只能输入正整数`,
    'en': `Only positive integers can be entered`
  },
  '339': {
    'zh_CN': `超过最大可激活数`,
    'en': `Exceeds the maximum number`
  },
  '340': {
    'zh_CN': `抽奖号码`,
    'en': `lucky number`
  },
  '341': {
    'zh_CN': `幸运号码`,
    'en': `winning number`
  },
  '342': {
    'zh_CN': `待生成`,
    'en': `To be generated`
  },
  '343': {
    'zh_CN': `未参与`,
    'en': `Not participated`
  },
  '344': {
    'zh_CN': `直推`,
    'en': `direct invitee`
  },
  '345': {
    'zh_CN': `自购`,
    'en': `Self-purchase`
  },
  '346': {
    'zh_CN': `积分`,
    'en': `point`
  },
  '347': {
    'zh_CN': `查询中`,
    'en': `searching...`
  },
  '348': {
    'zh_CN': `商品名称已被团队成员设置不可见`,
    'en': `Product name has been set invisible by team members`
  },
  '349': {
    'zh_CN': `订单确认收货后次月25号可提现`,
    'en': `Withdrawal is available on the 25th of the following month after the order is confirmed and received`
  },
  '350': {
    'zh_CN': `订单编号：`,
    'en': `Order No: `
  },
  '351': {
    'zh_CN': `待付款`,
    'en': `pending payment`
  },
  '352': {
    'zh_CN': `已付款`,
    'en': `paid`
  },
  '353': {
    'zh_CN': `已完成`,
    'en': `done`
  },
  '354': {
    'zh_CN': `长按图片，识别图中二维码`,
    'en': `Long press the picture to identify the QR code`
  },
  '355': {
    'zh_CN': `送你新人专属福利`,
    'en': `special gifts for you`
  },
  '356': {
    'zh_CN': `比特盘-分布式存储`,
    'en': `BitDisk-Distributed Storage`
  },
  '357': {
    'zh_CN': `100G空间体验套餐`,
    'en': `100G space trail`
  },
  '358': {
    'zh_CN': `保存到相册`,
    'en': `save to album`
  },
  '359': {
    'zh_CN': `复制链接`,
    'en': `copy the link`
  },
  '360': {
    'zh_CN': `您的幸运号码`,
    'en': `your lucky number`
  },
  '361': {
    'zh_CN': `往期中奖`,
    'en': `previous wins`
  },
  '362': {
    'zh_CN': `开奖规则及计算方式`,
    'en': `winning rules and calculation`
  },
  '363': {
    'zh_CN': `待定`,
    'en': `To be determined`
  },
  '364': {
    'zh_CN': `截止时间待定`,
    'en': `Deadline to be determined`
  },
  '365': {
    'zh_CN': `根据沪深收盘股指作为开奖依据`,
    'en': `Based on the closing stock of Shanghai-Shenzhen Index`
  },
  '366': {
    'zh_CN': `截止后次日15:00后开奖（次日如遇证交所休市，则首个复盘日15:00后开奖）`,
    'en': `The winning number will be drawn after 15:00 the next day after the deadline (If the stock exchange is closed, the winning will be drawn after 15:00 on the first open day)`
  },
  '367': {
    'zh_CN': `开奖依据`,
    'en': `draw basis`
  },
  '368': {
    'zh_CN': `参与号码总票数：`,
    'en': `Total votes of participating numbers: `
  },
  '369': {
    'zh_CN': `深沪指数截图`,
    'en': `Screenshot of Shenzhen-Shanghai Index`
  },
  '370': {
    'zh_CN': `待开奖`,
    'en': `To be drawn`
  },
  '371': {
    'zh_CN': `本期中奖用户`,
    'en': `winning user in this issue`
  },
  '372': {
    'zh_CN': `查看详情`,
    'en': `details`
  },
  '373': {
    'zh_CN': `公示内容`,
    'en': `Publicity`
  },
  '374': {
    'zh_CN': `参数错误`,
    'en': `parameter error`
  },
  '375': {
    'zh_CN': `BTD夺宝`,
    'en': `Treasure Race`
  },
  '376': {
    'zh_CN': `攻略`,
    'en': `tips`
  },
  '377': {
    'zh_CN': `已揭晓`,
    'en': `Announced`
  },
  '378': {
    'zh_CN': `订单详情`,
    'en': `order details`
  },
  '379': {
    'zh_CN': `待转账`,
    'en': `to be transferred`
  },
  '380': {
    'zh_CN': `订单转账超时`,
    'en': `transfer timed out`
  },
  '381': {
    'zh_CN': `已过期`,
    'en': `expired`
  },
  '382': {
    'zh_CN': `已取消`,
    'en': `Cancelled`
  },
  '383': {
    'zh_CN': `需要转账`,
    'en': `to be transferred`
  },
  '384': {
    'zh_CN': `立即转账`,
    'en': `transfer now`
  },
  '385': {
    'zh_CN': `已转账`,
    'en': `transferred`
  },
  '386': {
    'zh_CN': `手动确认`,
    'en': `confirm manually`
  },
  '387': {
    'zh_CN': `类型`,
    'en': `types`
  },
  '388': {
    'zh_CN': `夺宝消耗`,
    'en': `Treasure Race spend`
  },
  '389': {
    'zh_CN': `支付方式`,
    'en': `payment method`
  },
  '390': {
    'zh_CN': `参与期数`,
    'en': `participated issue`
  },
  '391': {
    'zh_CN': `订单号`,
    'en': `order number`
  },
  '392': {
    'zh_CN': `复制`,
    'en': `copy`
  },
  '393': {
    'zh_CN': `创建时间`,
    'en': `Created time`
  },
  '394': {
    'zh_CN': `完成时间`,
    'en': `Complete time`
  },
  '395': {
    'zh_CN': `取消订单`,
    'en': `cancel the order`
  },
  '396': {
    'zh_CN': `夺宝订单详情`,
    'en': `order details of Treasure Racde`
  },
  '397': {
    'zh_CN': `您确定要取消订单{0}`, //您确定要取消订单ORDER001
    'en': `Are you sure you want to cancel the order {0}?`
  },
  '398': {
    'zh_CN': `参与条件`,
    'en': `Participating conditions`
  },
  '399': {
    'zh_CN': `开奖时间`,
    'en': `Draw time`
  },
  '399.1': {
    'zh_CN': `夺宝活动截止前，均可参与。`,
    'en': `You can participate in the treasure racde before the deadline.`
  },
  '400': {
    'zh_CN': `满足当期的夺宝人数要求后截止。`,
    'en': `the race will end when meeting the number of total participant`
  },
  '401': {
    'zh_CN': `参与当期夺宝所有幸运号进行公示。`,
    'en': `All lucky numbers in this issue publicized`
  },
  '402': {
    'zh_CN': `公示结束次日15点后随机产生1名中奖用户，届时官方会及时通报开奖结果。（用户亦可自行计算核实开奖号）`,
    'en': `A winning user will be randomly generated after 15:00 on the day after the publicity ends, the result will be notified at that time. (Users can also calculate and verify the winning number by themselves)`
  },
  '403': {
    'zh_CN': `开奖方式`,
    'en': `how to draw`
  },
  '404': {
    'zh_CN': `夺宝满员截止公示1天（含截止日），次日基于沪深收盘股指作为计算依据。（次日如遇证交所休市，则采集将来首个交易日收盘股指作为依据）`,
    'en': `all numbers of Treasure Race will be publicized for 1 day (including the deadline day), and the calculation is based on the closing stock of Shanghai-Shenzhen Index of next day . (If the stock exchange is closed on the next day, the closing stock index of the next trading day will be collected as the basis)`
  },
  '405': {
    'zh_CN': `开奖公式`,
    'en': `draw formula`
  },
  '406': {
    'zh_CN': `开奖当日(上证指数×深圳成指）取整数 ÷本期抽奖号码总个数 取余数`,
    'en': `On the day of the draw, Shanghai Stock Index × Shenzhen Component Index (take the whole number) ÷ the total draw numbers in this issue, and take the remainder`
  },
  '407': {
    'zh_CN': `2860.08乘以10721.78取结果的整数部分再和2000抽奖号码个数相除后取余数，最终所得的值为1148。`,
    'en': `2860.08 × 10721.78, take the integer part of the result and divide it by the number of the 2000 draw numbers and take the remainder. The final value is 1148.`
  },
  '408': {
    'zh_CN': `则本期开奖号为1148`,
    'en': `therefore, the draw number for this issue is 1148`
  },
  '409': {
    'zh_CN': `余数为0时，开奖号即为2000`,
    'en': `When the remainder is 0, the number is 2000`
  },
  '410': {
    'zh_CN': `参与方式`,
    'en': `how to participate`
  },
  '411': {
    'zh_CN': `认证用户使用BTD兑换幸运号码，每个认证账户每期只能参与一次，每次可兑换1~5个幸运号码，幸运号码由系统随机生成。`,
    'en': `Valid users can use BTD to redeem lucky numbers. Each valid account can only participate once per issue, and can redeem 1~5 lucky numbers each time. The lucky numbers are randomly generated by the system.`
  },
  '412': {
    'zh_CN': `活动细则`,
    'en': `Rules`
  },
  '413': {
    'zh_CN': `用户参与夺宝活动后将获得1~5个幸运号码。`,
    'en': `Treasure Race`
  },
  '414': {
    'zh_CN': `参与当期满员后，将所有幸运号码从小到大依次排序，排列的序号即为幸运号码所对应的抽奖号码。`,
    'en': `After participating in the Treasure Race, users will get 1~5 lucky numbers`
  },
  '415': {
    'zh_CN': `抽奖号码若与本期开奖号码完全匹配，则表示夺宝成功（中奖）。`,
    'en': `If the lucky numbers exactly match the winning numbers of this issue, the lucky number is won (winning)`
  },
  '416': {
    'zh_CN': `每期夺宝活动都有开奖人数要求，只有参与人数达到要求才会开奖。`,
    'en': `There is a requirement for the number of participants in each Treasure Race, and it will be drawn only if the number meets the requirements`
  },
  '417': {
    'zh_CN': `未达到该期参与人数要求的夺宝活动将一直持续，直至满足人员数量方能公示并开奖。`,
    'en': `the race will continue until the number of participants met the requirements, and the draw can be made.`
  },
  '418': {
    'zh_CN': `夺宝活动参与后不能取消。`,
    'en': `Treasure Race cannot be cancelled after participating`
  },
  '419': {
    'zh_CN': `奖品发放`,
    'en': `award prize`
  },
  '420': {
    'zh_CN': `客服人员在2~3个工作日主动联系中奖用户，沟通兑奖事宜如收货地址等，如公布开奖后15天内未能联系到中奖用户，视为中奖用户主动放弃奖品。`,
    'en': `The customer service will contact the winning user within 2~3 working days to communicate the redemption matters such as the delivery address. If fails to be contacted within 15 days after the draw, the winning user will be deemed to have given up the prize voluntarily.`
  },
  '421': {
    'zh_CN': `实物奖品不支持退换货，不支持折现。（售后流程走厂家售后流程）`,
    'en': `material objectdo not support return or exchange, and do not support discounts. (After-sales process follow the manufacturer's after-sales process)`
  },
  '422': {
    'zh_CN': `虚拟奖品直接发放至夺宝中奖账户，不另行通知。`,
    'en': `The virtual prizes will be distributed directly to the winning account without notice.`
  },
  '423': {
    'zh_CN': `特别提醒`,
    'en': `Reminder`
  },
  '424': {
    'zh_CN': `若用户存在不正当手段（如侵犯第三人合法权益、扰乱系统、实施网络攻击、恶意套现、用机器模拟客户端及利用系统、规则漏洞作弊等）获取不当利益或有碍于其他用户公平参与活动或有违活动举办目的的记录或行为，用户的夺宝活动参与资格可能被取消、参加活动所获得的奖品或权益可能被追回。如造成损失或不良影响的，保留必要时追求法律责任的权利。`,
    'en': `If the user has improper behaviors (such as infringing on the legitimate rights and interests of a third party, disrupting the system, performing network attacks, malicious cashing out, using machines to simulate the client and cheating on rules and vulnerabilities, etc.) to obtain improper benefits or hinder the fair participation of other users or records or actions that violate the purpose of holding the activity, the user's eligibility to participate in may be cancelled, and the prizes or rights obtained by participating in the activity may be recovered. If losses or adverse effects are caused, it reserves the right to pursue legal liabilities when necessary.`
  },
  '425': {
    'zh_CN': `用户同意并授权将自身的账户昵称、头像用于本次活动的公开展示。`,
    'en': `The user agrees and authorizes the use of his account nickname and avatar for the public display of this activity.`
  },
  '426': {
    'zh_CN': `如出现不可抗力或情势变更的情况（包括自然灾害事件、活动受政府机关指令需停止举办或调整的，活动遭受网络攻击或因系统故障需暂停举办等），以及因用户帐户异常情况无法正常参与夺宝活动的，活动官方及相关合作机构免于承担责任。`,
    'en': `In the event of force majeure or changes in circumstances (including natural disasters, activities that require suspension or adjustment by government agencies, cyber attacks or suspension due to system failures, etc.), and abnormal user accounts that cannot normally participate, the official of the activity and related cooperative organizations are exempted from responsibility for the race.`
  },
  '427': {
    'zh_CN': `在法律法规许可的范围内，活动方可以根据本活动的实际举办情况对活动规则进行变动或调整，相关变动或调整将公布本活动的相关页面上，公布后依法生效。`,
    'en': `Within the limits permitted by laws and regulations, the activity party can make changes or adjustments to the rules based on the actual situation. The relevant changes or adjustments will be published on the relevant page and will take effect after being announced.`
  },
  '428': {
    'zh_CN': `夺宝活动官方有权根据业务情况终止、暂停、取消、恢复本夺宝活动。`,
    'en': `Treasure Race reserves the right to terminate, suspend, cancel, and resume the activity based on business conditions.`
  },
  '429': {
    'zh_CN': `夺宝`,
    'en': `Treasure Race`
  },
  '430': {
    'zh_CN': `转账成功`,
    'en': `success`
  },
  '431': {
    'zh_CN': `参与夺宝成功`,
    'en': `success`
  },
  '432': {
    'zh_CN': `知道了`,
    'en': `I know`
  },
  '433': {
    'zh_CN': `全选`,
    'en': `select all`
  },
  '434': {
    'zh_CN': `批量删除`,
    'en': `mass deletion`
  },
  '435': {
    'zh_CN': `一键更新`,
    'en': `one-click update`
  },
  '436': {
    'zh_CN': `取消`,
    'en': `Cancel`
  },
  '436.1': {
    'zh_CN': `确定`,
    'en': `Confirm`
  },
  '437': {
    'zh_CN': `我的收藏`,
    'en': `favorite`
  },
  '438': {
    'zh_CN': `取消收藏`,
    'en': `cancle`
  },
  '439': {
    'zh_CN': `复制文案`,
    'en': `copy the content`
  },
  '440': {
    'zh_CN': `保存图片`,
    'en': `save the picture`
  },
  '441': {
    'zh_CN': `下载BTD Wallet再省`,
    'en': `download BTD Wallet`
  },
  '442': {
    'zh_CN': `邀请码`,
    'en': ` invitation code`
  },
  '443': {
    'zh_CN': `邀下单地址`,
    'en': `order address`
  },
  '444': {
    'zh_CN': `操作成功`,
    'en': `success`
  },
  '445': {
    'zh_CN': `我的订单`,
    'en': `my order`
  },
  '446': {
    'zh_CN': `搜索订单编号`,
    'en': `search order number`
  },
  '447': {
    'zh_CN': `对上级屏蔽订单信息`,
    'en': `block order information from referrer`
  },
  '448': {
    'zh_CN': `团队订单`,
    'en': `team order`
  },
  '449': {
    'zh_CN': `全部`,
    'en': `all`
  },
  '450': {
    'zh_CN': `修改成功`,
    'en': `success`
  },
  '451': {
    'zh_CN': `输入商品名或关键词搜索`,
    'en': `please enter the product or key word`
  },
  '452': {
    'zh_CN': `搜索`,
    'en': `search`
  },
  '453': {
    'zh_CN': `热搜发现`,
    'en': ` top search`
  },
  '454': {
    'zh_CN': `历史搜索`,
    'en': `history`
  },
  '455': {
    'zh_CN': `清空历史搜索成功`,
    'en': `Clear history successfully`
  },
  '456': {
    'zh_CN': `请输入商品名或关键词搜索`,
    'en': `please enter the product or key word`
  },
  '457': {
    'zh_CN': `商品分享`,
    'en': `share`
  },
  '458': {
    'zh_CN': `是否显示邀请码`,
    'en': `Whether to show the invitation code`
  },
  '459': {
    'zh_CN': `下单地址`,
    'en': `Order address`
  },
  '460': {
    'zh_CN': `请识别图片二维码下单`,
    'en': `Please identify the QR code of the picture to place an order`
  },
  '461': {
    'zh_CN': `预估奖励收益`,
    'en': `estimated earnings`
  },
  '462': {
    'zh_CN': `微信`,
    'en': `WeChat`
  },
  '463': {
    'zh_CN': `已复制文案`,
    'en': `content copied`
  },
  '464': {
    'zh_CN': `输入手机号搜索`,
    'en': `please enter the phone number`
  },
  '465': {
    'zh_CN': `注册时间`,
    'en': `registration time`
  },
  '466': {
    'zh_CN': `购买活跃度(上限200)`,
    'en': `buying point(up to 200)`
  },
  '467': {
    'zh_CN': `出单数量`,
    'en': `Number of orders`
  },
  '468': {
    'zh_CN': `今日新增`,
    'en': `Added today`
  },
  '469': {
    'zh_CN': `昨日新增`,
    'en': `Added yesterday`
  },
  '470': {
    'zh_CN': `我的团队`,
    'en': `my team`
  },
  '471': {
    'zh_CN': `购买活跃度`,
    'en': `buying point`
  },
  '472': {
    'zh_CN': `个人购买活跃`,
    'en': `self buying point`
  },
  '473': {
    'zh_CN': `直推购买活跃`,
    'en': `referral buying point`
  },
  '474': {
    'zh_CN': `学员导师`,
    'en': `learning guider`
  },
  '475': {
    'zh_CN': `见习导师`,
    'en': `intern guider`
  },
  '476': {
    'zh_CN': `正式导师`,
    'en': `regular guider`
  },
  '477': {
    'zh_CN': `活跃导师`,
    'en': `guider guider`
  },
  '478': {
    'zh_CN': `成功导师`,
    'en': `advanced guider`
  },
  '479': {
    'zh_CN': `大咖导师`,
    'en': `master guider`
  },
  '480': {
    'zh_CN': `出单数据统计`,
    'en': `Order data`
  },
  '481': {
    'zh_CN': `今日直属订单数`,
    'en': `Today's direct orders`
  },
  '482': {
    'zh_CN': `总&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;计`,
    'en': `total`
  },
  '483': {
    'zh_CN': `退&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;单`,
    'en': `refund`
  },
  '484': {
    'zh_CN': `单`, //10单
    'en': `orders`
  },
  '485': {
    'zh_CN': `收入报表`,
    'en': `earning statement`
  },
  '486': {
    'zh_CN': `我通过享购赚了`,
    'en': `Through shopping, I earned `
  },
  '487': {
    'zh_CN': `收益(元)`,
    'en': `yuan`
  },
  '488': {
    'zh_CN': `我的订单收益`,
    'en': `my order earnings`
  },
  '489': {
    'zh_CN': `预估收入`,
    'en': `estimated earnings`
  },
  '490': {
    'zh_CN': `自购订单`,
    'en': `self-buying order`
  },
  '491': {
    'zh_CN': `团队订单收益`,
    'en': `team order earnings`
  },
  '492': {
    'zh_CN': `自推订单`,
    'en': `Self-promoting order`
  },
  '493': {
    'zh_CN': `本月预估总收益(元)`,
    'en': `estimated total income this month (yuan)`
  },
  '494': {
    'zh_CN': `直推预估`,
    'en': `referral estimated`
  },
  '495': {
    'zh_CN': `奖励池预估`,
    'en': `reward pool estimated`
  },
  '496': {
    'zh_CN': `上月预估总收益(元)`,
    'en': `Estimated total earnings last month (yuan)`
  },
  '497': {
    'zh_CN': `导师等级`,
    'en': `guider level`
  },
  '498': {
    'zh_CN': `升级条件`,
    'en': `upgrade conditions`
  },
  '499': {
    'zh_CN': `如何获得购买活跃度`,
    'en': `how to get buying points`
  },
  '500': {
    'zh_CN': `权益`,
    'en': `Rights`
  },
  '501': {
    'zh_CN': `佣金奖励池分配`,
    'en': `cashback pool allocation`
  },
  '502': {
    'zh_CN': `自购省钱，返利{0}%收益`,//自购省钱，返利10%收益
    'en': `self-purchase to get {0}% cashback`
  },
  '503': {
    'zh_CN': `自推{0}%佣金`,//自推10%佣金
    'en': `self-promotion to get {0}% cashback`
  },
  '504': {
    'zh_CN': `直属推广{0}%佣金`,//直属推广10%佣金
    'en': `direct-promotion to get {0}% cashback `
  },
  '505': {
    'zh_CN': ["零","一","二","三","四","五","六","七","八","九"],
    'en': ["0","1","2","3","4","5","6","7","8","9"]
  },
  '506': {
    'zh_CN': `推广商品提升导师等级`,
    'en': `Promote products to raise the level of guider`
  },
  '507': {
    'zh_CN': `今日预估`,
    'en': `Today's estimate`
  },
  '508': {
    'zh_CN': `昨日预估`,
    'en': `Yesterday's estimate`
  },
  '509': {
    'zh_CN': `本月预估`,
    'en': `this month's estimate`
  },
  '510': {
    'zh_CN': `上月预估`,
    'en': `last month's estimate`
  },
  '511': {
    'zh_CN': `余额`,
    'en': `balance`
  },
  '512': {
    'zh_CN': `提现`,
    'en': `withdraw`
  },
  '513': {
    'zh_CN': `推荐商品`,
    'en': `Promoting products`
  },
  '514': {
    'zh_CN': `一、提现`,
    'en': `1. Withdrawal`
  },
  '515': {
    'zh_CN': `1. 提现支持平台`,
    'en': `(1). Platforms that support withdrawal`
  },
  '516': {
    'zh_CN': `支付宝平台提现`,
    'en': `Alipay withdrawal`
  },
  '517': {
    'zh_CN': `您可通过APP内向您开放的提现功能，将您享购账户中的资金转入您指定的支付宝账户中。享购将于收到您的申请后，尽快将相应的款项汇入您指定的支付宝账户中。`,
    'en': `You can transfer the cashback in your account to your designated Alipay account through the withdrawal function in the APP. Shopping will remit the corresponding cashback to your designated Alipay account as soon as possible after receiving your application.`
  },
  '518': {
    'zh_CN': `2、您须保证自己所填写的提现资料正确有效，且支付宝账户与APP账户预留实名信息相互匹配；`,
    'en': `(2).You must ensure that the withdrawal information you fill in is correct and valid, and that the real-name information reserved for your Alipay account and APP account matches each other; `
  },
  '519': {
    'zh_CN': `3、支付宝平台账户名错误、账户未激活、账户未经实名认证，我们不进行检测，一旦支付后造成的金额被冻结、消失概与BTD、享购及平台无关；`,
    'en': `(3). We will not test if your Alipay name is wrong, the account is not activated, and the account has not been verified by real name, once the amount is frozen or disappeared after payment, it has nothing to do with BTD, Shopping or the platform;`
  },
  '520': {
    'zh_CN': `4、对于无法支付的提现申请，我们将进行退回处理；`,
    'en': `(4). For withdrawal that cannot be paid, we will return them;`
  },
  '521': {
    'zh_CN': `5、其它在此处未写明的不符合提现支付的条件者，以处理支付时发送的系统信息为准。`,
    'en': `(5). For those who do not meet the conditions of withdrawal that are not specified here, the system information sent when the payment is processed shall prevail.`
  },
  '522': {
    'zh_CN': `二、费用`,
    'en': `2. Cost`
  },
  '523': {
    'zh_CN': `享购在推广期间，免收提现手续费。`,
    'en': `During the promotion, Shopping is free of withdrawal fees.`
  },
  '524': {
    'zh_CN': `三、免责条款`,
    'en': `3. Disclaimer`
  },
  '525': {
    'zh_CN': `1、您了解，上述提现服务涉及BTD、享购与支付宝的支付合作。您同意：`,
    'en': `(1).You understand that the above withdrawal services involve payment cooperation between BTD, Shopping and Alipay. You agree:`
  },
  '526': {
    'zh_CN': `(a) 受支付宝机构支进行资金代扣及划转的现状等各种原因所限，BTD、享购不对前述服务的资金到账时间做任何承诺，也不承担与此相关的责任，包括但不限于由此产生的利息、货币贬值等损失；`,
    'en': `(a) Due to various reasons such as the current status of deductions and transfers made by Alipay institutions, BTD and Shopping do not make any commitments regarding the time for the withdraw to arrive for the aforementioned services, nor do they assume any responsibilities related to this, including but not limited to losses such as interest and currency depreciation;`
  },
  '527': {
    'zh_CN': `(b) 一经使用前述服务，即表示您授权BTD、享购进行相关操作，且该等操作是不可撤销和不可逆转的，您不能以任何理由拒绝付款或要求取消交易。就前述服务，BTD、享购暂不会向您收取费用，但您应按照支付宝的规定向支付宝支付费用，您与支付宝之间就费用支付事项产生的争议或纠纷，与BTD、享购无关。`,
    'en': `(b) Once you use the aforementioned services, it means that you authorize BTD and Shopping to perform related operations, and these operations are irrevocable and irreversible, and you cannot refuse payment or request cancellation of the transaction for any reason. For the aforementioned services, BTD and Shopping will not charge you for the time being, but you should pay Alipay in accordance with Alipay's regulations. Disputes between you and Alipay on the payment of fees have nothing to do with BTD and Shopping.`
  },
  '528': {
    'zh_CN': `2、您保证并承诺您通过BTD、享购平台用于交易的资金来源合法。`,
    'en': `(2).You guarantee that the source of money you use for transactions through the BTD and Shopping is legal.`
  },
  '529': {
    'zh_CN': `3、享购有权基于交易安全等方面的考虑不时设定涉及提现交易的相关事项， 包括但不限于交易限额、交易次数等。您了解，BTD、享购的前述设定可能会对您的交易造成一定不便，您对此没有异议。`,
    'en': `(3).Shopping has the right to set relevant matters involving withdrawal transactions from time to time based on considerations such as transaction security, including but not limited to transaction limits, number of transactions, etc. You understand that the aforementioned settings of BTD and Shopping may cause some inconvenience to your transaction, and you have no objection to this.`
  },
  '530': {
    'zh_CN': `4、如果BTD、享购发现了因系统故障或其他任何原因导致的处理错误，无论有利于BTD、享购还是有利于您，BTD、享购都有权在以电子邮件等方式通知您后纠正该错误。如果该错误导致您实际收到的金额少于您应获得的金额，则BTD、享购在确认该处理错误后会尽快将您应收金额与实收金额之间的差额存入您的会员账户。如果该错误导致您实际收到的金额多于您应获得的金额，则无论错误的性质和原因为何，您都应及时根据BTD、享购向您发出的有关纠正错误的通知和具体要求返还多收的款项。您理解并同意，您因前述处理错误而多付或少付的款项均不计利息， BTD、享购不承担因前述处理错误而导致的任何损失或责任 （包括您可能因前述错误导致的利息、汇率等损失），因享购恶意而导致的处理错误除外。`,
    'en': `(4).If BTD and Shopping find an error due to a system failure or any other reason, regardless of whether it is beneficial to BTD, Shopping or you, BTD and Shopping have the right to correct the error after notifying you by email, etc. If the error causes the amount that you actually received is less than the amount you should have received, BTD and Shopping will deposit the difference between your receivable amount and the actual amount into your member account as soon as possible after confirming the error. If the error caused that your actually received is more than the amount you should have received, regardless of the nature and cause of the error, you should promptly refund the amount in accordance with the notice of error correction and specific requirements issued to you by BTD and Shopping. You understand and agree that no interest will be charged for any overpayment or underpayment due to the aforementioned errors. BTD and Shopping shall not be liable for any losses or liabilities caused by the aforementioned errors (including the interest, loss of exchange rate, etc.), except for errors caused by malicious intentions.`
  },
  '531': {
    'zh_CN': `5、在任何情况下，对于您使用享购提现服务过程中涉及由支付宝提供相关服务的责任由支付宝承担，BTD、享购不承担该等责任，包括但不限于：`,
    'en': `(5).In any case, Alipay bears the responsibility for the related services provided by Alipay in the process of withdrawal service. BTD and Shopping shall not bear such responsibilities, including but not limited to:`
  },
  '532': {
    'zh_CN': `1）支付宝方未按照您和/或享购指令进行操作引起的任何损失或责任；`,
    'en': `1) Any loss or liability caused by Alipay’s failure to follow your and/or Shopping instructions;`
  },
  '533': {
    'zh_CN': `2）因支付宝方原因导致资金未能及时到账或未能到账引起的任何损失或责任；`,
    'en': `2) Any loss or liability caused by the failure of the funds to arrive in the account due to the Alipay party;`
  },
  '534': {
    'zh_CN': `3）支付宝对交易限额或次数等方面的限制而引起的任何损失或责任；`,
    'en': `3) Any loss or liability caused by Alipay's restrictions on transaction limits or times;`
  },
  '535': {
    'zh_CN': `4）因其他第三方的行为或原因导致的任何损失或责任。`,
    'en': `4) Any loss or liability caused by the actions or causes of other third parties.`
  },
  '536': {
    'zh_CN': `已阅读`,
    'en': `I have read it carefully.`
  },
  '537': {
    'zh_CN': `1.隐私政策的适用性`,
    'en': `1. Applicability of Privacy Policy`
  },
  '538': {
    'zh_CN': `使用享购提现服务时，您同意和接受本隐私政策有关条款以及我们使用和披露隐私政策列出您的个人信息。`,
    'en': `When using the withdrawal service, you agree and accept the relevant terms of this privacy policy and our use and disclosure privacy policy to list your personal information.`
  },
  '539': {
    'zh_CN': `我们会定期检阅本隐私政策，同时有权随时修改和更新本隐私政策，如更改将马上生效，我们将在享购特别通知。如您继续使用提现服务表示您接受此条款。请定期详阅本隐私政策和复制一份作为记录。`,
    'en': `We will review this privacy policy on a regular basis, and at the same time have the right to modify and update this privacy policy at any time. Any changes will take effect immediately, and we will give a special notice in Shopping. If you continue to use the withdrawal service, it means that you accept this clause. Please read this privacy policy regularly and make a copy.`
  },
  '540': {
    'zh_CN': `2.个人信息收集及用途`,
    'en': `2. Collection and use of personal information`
  },
  '541': {
    'zh_CN': `当您使用享购提现服务时，我们需要收集您的个人信息，并将其作为结算、付款、缴税相关用途，我们将加密储存确保您的个人信息安全。`,
    'en': `When you use the withdrawal service, we need to collect your personal information and use it for settlement, payment, and tax payment and other related purposes. We will store your personal information by encryptionto ensure the safety.`
  },
  '542': {
    'zh_CN': `为了提高我们的服务和质量，当您使用享购提现服务时，我们系统将会保存您的一些管理信息，包括但不限于IP地址、登录时间及日期、登录APP使用的手机系统、型号和软件错误报告。`,
    'en': `In order to improve our service and quality, when you use the withdrawal service, our system will save some of your management information, including but not limited to IP address, login time and date, mobile phone system, model and software error report.`
  },
  '543': {
    'zh_CN': `当您使用享购提现服务时，为了验证您的帐户和核对账户资金情况，我们可能收集您的个人信息。`,
    'en': `We may collect your personal information in order to verify your account and check the funds in your account when you use the withdrawal service.`
  },
  '544': {
    'zh_CN': `您同意我们使用您的个人信息：`,
    'en': `You agree to our use of your personal information:`
  },
  '545': {
    'zh_CN': `a）管理您的帐户，进行身份验证、防止违法的融资活动。`,
    'en': `a) Manage your account, perform identity verification, and prevent illegal financing activities.`
  },
  '546': {
    'zh_CN': `b）确认您的提现信息。`,
    'en': `b) Confirm your withdrawal information.`
  },
  '547': {
    'zh_CN': `c）提现服务统计和审核。 `,
    'en': `c) Statistics and review of withdrawal services.`
  },
  '548': {
    'zh_CN': `d）提现服务市场营销调查和数据分析。`,
    'en': `d) Marketing survey and data analysis of withdrawal services.`
  },
  '549': {
    'zh_CN': `3.个人信息的准确性`,
    'en': `3. Accuracy of personal information`
  },
  '550': {
    'zh_CN': `当您使用享购提现服务时，如您的个人信息有任何更改，您有责任在使用提现服务之前进行更正，我们可能要求您提供相关资料，以便验证您的身份。`,
    'en': `When you use thecwithdrawal service, if there are any changes to your personal information, you are responsible for making corrections before using the service. We may ask you to provide relevant information in order to verify your identity.`
  },
  '551': {
    'zh_CN': `如需索取您在我方的个人信息、您对本隐私政策及处理您个人信息方面有任何疑问，请联系客服咨询`,
    'en': `If you need to obtain your personal information from us, if you have any questions about this privacy policy and the handling of your personal information, please contact customer service for consultation`
  },
  '552': {
    'zh_CN': `4.披露`,
    'en': `4. Disclosure`
  },
  '553': {
    'zh_CN': `我们可能会披露您的个人信息：`,
    'en': `We may disclose your personal information:`
  },
  '554': {
    'zh_CN': `4.1) 如是通过法律要求，我们可能将向第三方披露您的个人信息，同时我们也将从第三方获取您允许的个人信息进行核查和鉴别;`,
    'en': `4.1) If required by law, we may disclose your personal information to a third party, and at the same time, we will obtain personal information permitted by you from the third party for verification and identification;`
  },
  '555': {
    'zh_CN': `4.2) 如原则上我们必须做的：`,
    'en': `4.2)  What we must do as in principle:`
  },
  '556': {
    'zh_CN': `4.2.1 我们需要遵行的法律或法律程序;`,
    'en': `4.2.1 The laws or legal procedures we need to follow;`
  },
  '557': {
    'zh_CN': `4.2.2 保护和捍卫我们的权利或财产;`,
    'en': `4.2.2 To protect and defend our rights or property;`
  },
  '558': {
    'zh_CN': `4.2.3 保护提现服务或公众用户的人身安全;`,
    'en': `4.2.3 Protect withdrawal services or the personal safety of public users;`
  },
  '559': {
    'zh_CN': `4.3) 给任何监管、授权部门或机构;`,
    'en': `4.3) To any regulatory or authorized department or agency;`
  },
  '560': {
    'zh_CN': `4.4) 给第三方作为提现结算或付款相关用途;`,
    'en': `4.4) To third parties for cash withdrawal settlement or payment related purposes;`
  },
  '561': {
    'zh_CN': `4.5) 给为我们提供服务（包括APP）的第三方或代表方;`,
    'en': `4.5) To third parties or representatives who provide services to us (including APP);`
  },
  '562': {
    'zh_CN': `4.6) 给任何收购我们或我们有合作业务的第三方;`,
    'en': `4.6) To any third party that has acquired us or our cooperative business;`
  },
  '563': {
    'zh_CN': `4.7) 征得您的同意;`,
    'en': `4.7) With your consent;`
  },
  '564': {
    'zh_CN': `4.8) 作为恢复灾难用途。`,
    'en': `4.8) For disaster recovery purposes.`
  },
  '565': {
    'zh_CN': `作为上述用途，我们也可将您的个人信息披露给我们旗下相关机构或第三方，您的个人信息也有可能在中国以外区域进行处理，我们将确保在此过程中严格遵循资料保护法处理您的个人信息。`,
    'en': `For the above-mentioned purposes, we may also disclose your personal information to our relevant agencies or third parties. Your personal information may also be processed outside of China. We will ensure that in this process, we will strictly comply with the data protection law to process your information.`
  },
  '566': {
    'zh_CN': `5.安全性`,
    'en': `5. Security`
  },
  '567': {
    'zh_CN': `我们将遵循资料保护法程序，确保所收集的个人信息准确记录和安全性。`,
    'en': `We will follow the procedures of the Data Protection Law to ensure that the personal information collected is accurately recorded and secured.`
  },
  '568': {
    'zh_CN': `我们无法确保您通过网络传送给我们的信息，包括个人资料信息的安全性，但我们收到您的资料后，将遵从资料保护法确保您的信息不被滥用、泄露及未授权使用。`,
    'en': ``
  },
  '569': {
    'zh_CN': `6.网络传送`,
    'en': `6. Network transmission`
  },
  '570': {
    'zh_CN': `由于网络是全球性的，使用网络收集和处理个人信息必然涉及到跨国的传送，因此，登录我们网站/应用联系我们，告知您接受并同意我们以此方式处理您的个人信息。`,
    'en': `Since the Internet is global, the use of the Internet to collect and process personal information will inevitably involve transnational transmission. Therefore, log in to our website/app and contact us to inform you that you accept and agree to our processing of your personal information in this way.`
  },
  '571': {
    'zh_CN': `收支明细`,
    'en': `detail of income and expenditure`
  },
  '572': {
    'zh_CN': `实扣`,
    'en': `real deduction amount`
  },
  '573': {
    'zh_CN': `到账`,
    'en': ` received`
  },
  '574': {
    'zh_CN': `京东自购/推`,
    'en': ` self-purchasing/promoting in Jingdong`
  },
  '575': {
    'zh_CN': `京东下级贡献`,
    'en': `invitee contributing in Jingdong`
  },
  '576': {
    'zh_CN': `佣金池`,
    'en': `cashback pool`
  },
  '577': {
    'zh_CN': `提现失败退回`,
    'en': `fail to withdraw and send back`
  },
  '578': {
    'zh_CN': `推广奖励`,
    'en': `Promoting rewards`
  },
  '579': {
    'zh_CN': `提现中`,
    'en': `Withdrawing`
  },
  '580': {
    'zh_CN': `提现完成`,
    'en': `Withdrawal completed`
  },
  '581': {
    'zh_CN': `提现失败`,
    'en': `fail to Withdraw`
  },
  '582': {
    'zh_CN': `退回完成`,
    'en': `refunded`
  },
  '583': {
    'zh_CN': `退回中`,
    'en': `refunding`
  },
  '584': {
    'zh_CN': `退回失败`,
    'en': `fail to refund`
  },
  '585': {
    'zh_CN': `已累加到待提现`,
    'en': `Has been added to be withdrawn`
  },
  '586': {
    'zh_CN': `未累加到待提现`,
    'en': `Not added to be withdrawn`
  },
  '587': {
    'zh_CN': `已累加到待提现`,
    'en': `Has been added to be withdrawn`
  },
  '588': {
    'zh_CN': `用户金额异常`,
    'en': `abnormal amount`
  },
  '589': {
    'zh_CN': `提现中心`,
    'en': `Withdrawal Center`
  },
  '590': {
    'zh_CN': `可提现`,
    'en': `Withdrawable`
  },
  '591': {
    'zh_CN': `获得返利`,
    'en': `get cashback`
  },
  '592': {
    'zh_CN': `已提现`,
    'en': `Withdrawn`
  },
  '593': {
    'zh_CN': `上月已结算`,
    'en': `Settled last month`
  },
  '594': {
    'zh_CN': `待结算`,
    'en': `To be settled`
  },
  '595': {
    'zh_CN': `本月已结算`,
    'en': `Settled this month`
  },
  '596': {
    'zh_CN': `本月25号后可提现上月已结算佣金`,
    'en': `After the 25th of this month, the settled cashback of last month can be withdrawn`
  },
  '597': {
    'zh_CN': `点击设置提现支付宝账号`,
    'en': `Click to set up the Alipay to withdraw `
  },
  '598': {
    'zh_CN': `修改`,
    'en': `edit`
  },
  '599': {
    'zh_CN': `温馨提示：请使用“{0}”实名认证的支付宝账户，否则会导致到账失败`,
    'en': `Reminder: Please use the real-name Alipay of "{0}", otherwise the cashback-receiving will fail`
  },
  '600': {
    'zh_CN': `提现金额`,
    'en': `withdrawal amount`
  },
  '601': {
    'zh_CN': `最大金额`,
    'en': `maximum amount`
  },
  '602': {
    'zh_CN': `代扣所得税：`,
    'en': `Withhold earnings tax: `
  },
  '603': {
    'zh_CN': `实际到账：`,
    'en': `actually received: `
  },
  '604': {
    'zh_CN': `完成`,
    'en': `Done`
  },
  '605': {
    'zh_CN': `确认提现`,
    'en': `Confirm`
  },
  '606': {
    'zh_CN': `感谢您的信任并使用提现服务！`,
    'en': `Thanks for your trust and use the cash withdrawal service!`
  },
  '607': {
    'zh_CN': `我们根据最新法律要求，更新了隐私条款，特地向您推送本提示。`,
    'en': `We have updated the privacy policy in accordance with the latest legal requirements, and specially push this reminder to you`
  },
  '608': {
    'zh_CN': `我们一直采取行业领先的安全防护措施来保护您的信息安全。我们会根据您使用服务的具体功能需要收集使用信息（可能涉及账户、交易提现、设备等相关信息）。我们不会向任何第三方提供您的信息，除非得到您的授权。`,
    'en': `We have always adopted industry-leading security protection measures to protect your information. We will collect usage information (which may involve account, transaction withdrawal, equipment and other related information) according to the specific functions of your use of the service. We will not provide your information to any third party unless authorized by you.`
  },
  '609': {
    'zh_CN': `若我们将信息用于您未授权用途或目的。我们会事先再次征求您的同意。您可以阅读我们完整的`,
    'en': `If we use the information for a purpose or purpose that you have not authorized. We will seek your consent again in advance. You can read our complete`
  },
  '610': {
    'zh_CN': `《提现-隐私条款》`,
    'en': `Withdrawal-Privacy Policy`
  },
  '611': {
    'zh_CN': `《提现-服务协议》`,
    'en': `Withdrawal-Service Agreement`
  },
  '612': {
    'zh_CN': `我已经仔细阅读以上相关条款及协议，并同意！`,
    'en': `I have read the relevant terms and agreements above carefully, and agree!`
  },
  '613': {
    'zh_CN': `请输入支付密码`,
    'en': `please enter the payment password `
  },
  '614': {
    'zh_CN': `忘记支付密码？`,
    'en': `forgot payment password?`
  },
  '615': {
    'zh_CN': `提交`,
    'en': `submit`
  },
  '616': {
    'zh_CN': `单笔提现金额{0}~{1}元，不支持小数位`, //单笔提现金额10~20元，不支持小数位
    'en': `Single withdrawal amount is {0}~{1} yuan, decimal places are not supported`
  },
  '617': {
    'zh_CN': `隐私条款`,
    'en': `Privacy Policy`
  },
  '618': {
    'zh_CN': `服务协议`,
    'en': `Service Agreement`
  },
  '619': {
    'zh_CN': `请输入10-10000的整数金额`,
    'en': `Please enter an integer from 10 to 10000`
  },
  '620': {
    'zh_CN': `请输入{0}-{1}的整数`, //请输入1-100的整数
    'en': `Please enter an integer from {0} to {1}`
  },
  '621': {
    'zh_CN': `请输入要提现金额`,
    'en': `please enter the withdraw number`
  },
  '622': {
    'zh_CN': `提现数量必须大于{0}`,
    'en': `the number must be more than {0}`
  },
  '623': {
    'zh_CN': `提现数量必须小于{0}`,
    'en': `the number must be less than {0}`
  },
  '624': {
    'zh_CN': `密码长度不小于八位`,
    'en': `the password should contain at least 8 chars`
  },
  '625': {
    'zh_CN': `提现成功`,
    'en': `success`
  },
  '626': {
    'zh_CN': `查询收费`,
    'en': `Inquiry charge`
  },
  '627': {
    'zh_CN': ``,
    'en': ``
  },
  '628': {
    'zh_CN': ``,
    'en': ``
  },
  '629': {
    'zh_CN': ``,
    'en': ``
  },
  '630': {
    'zh_CN': ``,
    'en': ``
  },
  '631': {
    'zh_CN': ``,
    'en': ``
  },
  '632': {
    'zh_CN': ``,
    'en': ``
  },
  '633': {
    'zh_CN': ``,
    'en': ``
  },
  '634': {
    'zh_CN': ``,
    'en': ``
  },
  '635': {
    'zh_CN': ``,
    'en': ``
  },
  '636': {
    'zh_CN': ``,
    'en': ``
  },
  '637': {
    'zh_CN': ``,
    'en': ``
  },
  '638': {
    'zh_CN': ``,
    'en': ``
  },
  '639': {
    'zh_CN': ``,
    'en': ``
  },
  '640': {
    'zh_CN': ``,
    'en': ``
  }
}

export {
  language
}



// WEBPACK FOOTER //
// ./src/utils/lan/multilingu.js